import React, { useState } from "react";
import "./CreatePost.css";
import { ImCross } from "react-icons/im";
import FollowLoader from "../../assets/FollowLoader";
import { ChatState } from "../../assets/context";
import { BiArrowBack } from "react-icons/bi";
import { storage } from "../../assets/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import axios from "axios";
import { ENDPOINT } from "../../assets/endpoint";

function CreatePost({ DisplayCreateBox }) {
  const { user, setMainLoader  } = ChatState();
  const [pic, setPic] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageGot, setImageGot] = useState(false);
  const [text, setText] = useState();
  const [goTofinal, setGotofinal] = useState(false);

  const postDetails = async (pics) => {
    if (pics === undefined) {
      alert("Image not selected !");
    }
    setLoading(true);
    const imageref = ref(storage, `images/${pics.name}`);
    uploadBytes(imageref, pics).then((photo) => {
      getDownloadURL(photo.ref).then((url) => {
        setPic(url);
        setImageGot(true);
        setLoading(false);
      });
    });
  };
  //  POST FUNCTION
  const postImage = async () => {
    if (pic && text) {
      const { data } = await axios.post(
        `${ENDPOINT}/posting`,
        {
          userId: user._id,
          

          description: text,
          image: pic,
        },
        {
          onUploadProgress: (load) => {
            setMainLoader(Math.round((load.loaded / load.total) * 100));
          },
        }
      );
      DisplayCreateBox();
      setPic("");
      setText("");
    } else if (text) {
      const { data } = await axios.post(
        `${ENDPOINT}/posting`,
        {
          userId: user._id,
     
          description: text,
        },
        {
          onUploadProgress: (load) => {
            setMainLoader(Math.round((load.loaded / load.total) * 100));
            console.log(Math.round((load.loaded / load.total) * 100));
          },
        }
      );
      DisplayCreateBox();

      setText("");
    } else if (pic) {
      const { data } = await axios.post(
        `${ENDPOINT}/posting`,
        {
          userId: user._id,
        

          image: pic,
        },
        {
          onUploadProgress: (load) => {
            setMainLoader(Math.round((load.loaded / load.total) * 100));
          },
        }
      );
      DisplayCreateBox();

    } else {
      alert("nothing to post ");
    }
  };

  const Goback = () => {
    setImageGot(false);
    setPic(null);
  };

  return (
    <>
      <div className="CreatePost_cointainer">
        <div className="Createpost_innerbox">
          <div className="CreatePost_selectImage">
            <span>Create New Post</span>
        <ImCross id="exit_cointainer" onClick={DisplayCreateBox} />
            <svg
              aria-label="Icon to represent media such as images or videos"
              class="_ab6-"
              color="#262626"
              fill="#262626"
              height="77"
              role="img"
              viewBox="0 0 97.6 77.3"
              width="96"
            >
              <path
                d="M16.3 24h.3c2.8-.2 4.9-2.6 4.8-5.4-.2-2.8-2.6-4.9-5.4-4.8s-4.9 2.6-4.8 5.4c.1 2.7 2.4 4.8 5.1 4.8zm-2.4-7.2c.5-.6 1.3-1 2.1-1h.2c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-.8.3-1.5.8-2.1z"
                fill="currentColor"
              ></path>
              <path
                d="M84.7 18.4 58 16.9l-.2-3c-.3-5.7-5.2-10.1-11-9.8L12.9 6c-5.7.3-10.1 5.3-9.8 11L5 51v.8c.7 5.2 5.1 9.1 10.3 9.1h.6l21.7-1.2v.6c-.3 5.7 4 10.7 9.8 11l34 2h.6c5.5 0 10.1-4.3 10.4-9.8l2-34c.4-5.8-4-10.7-9.7-11.1zM7.2 10.8C8.7 9.1 10.8 8.1 13 8l34-1.9c4.6-.3 8.6 3.3 8.9 7.9l.2 2.8-5.3-.3c-5.7-.3-10.7 4-11 9.8l-.6 9.5-9.5 10.7c-.2.3-.6.4-1 .5-.4 0-.7-.1-1-.4l-7.8-7c-1.4-1.3-3.5-1.1-4.8.3L7 49 5.2 17c-.2-2.3.6-4.5 2-6.2zm8.7 48c-4.3.2-8.1-2.8-8.8-7.1l9.4-10.5c.2-.3.6-.4 1-.5.4 0 .7.1 1 .4l7.8 7c.7.6 1.6.9 2.5.9.9 0 1.7-.5 2.3-1.1l7.8-8.8-1.1 18.6-21.9 1.1zm76.5-29.5-2 34c-.3 4.6-4.3 8.2-8.9 7.9l-34-2c-4.6-.3-8.2-4.3-7.9-8.9l2-34c.3-4.4 3.9-7.9 8.4-7.9h.5l34 2c4.7.3 8.2 4.3 7.9 8.9z"
                fill="currentColor"
              ></path>
              <path
                d="M78.2 41.6 61.3 30.5c-2.1-1.4-4.9-.8-6.2 1.3-.4.7-.7 1.4-.7 2.2l-1.2 20.1c-.1 2.5 1.7 4.6 4.2 4.8h.3c.7 0 1.4-.2 2-.5l18-9c2.2-1.1 3.1-3.8 2-6-.4-.7-.9-1.3-1.5-1.8zm-1.4 6-18 9c-.4.2-.8.3-1.3.3-.4 0-.9-.2-1.2-.4-.7-.5-1.2-1.3-1.1-2.2l1.2-20.1c.1-.9.6-1.7 1.4-2.1.8-.4 1.7-.3 2.5.1L77 43.3c1.2.8 1.5 2.3.7 3.4-.2.4-.5.7-.9.9z"
                fill="currentColor"
              ></path>
            </svg>
            <h3 style={{ fontWeight: "200" }}>Select photos and videos here</h3>
            <div className="create_button_post">
              {loading ? <FollowLoader /> : "Select Your Media"}
              <input
                type="file"
                onChange={(e) => postDetails(e.target.files[0])}
              />
            </div>
          </div>
          <div
            className="CreatePost_imagereceived"
            style={{ display: imageGot ? "flex" : "none" }}
          >
            <div className="CreatePost_imagereceived_head">
              <BiArrowBack onClick={Goback} />
              <span>Media</span>
              <button onClick={() => setGotofinal(true)}>Next</button>
            </div>
            { pic? 
            pic && pic.match(/\.(jpeg|jpg|png|gif)/g) != null ? (
              <img src={pic} alt="foto" />
            ) : (
              <video
                loop
                id="vedio_post"
                controls
                muted
                src={pic}
                webkit-playsinline="true"
                playsinline="true"
              />
            ):<FollowLoader />
          }
          </div>
          <div
            className="createPost_finalPage_box"
            style={{ display: goTofinal ? "flex" : "none" }}
          >
            <div className="createPost_final_head">
              <img src={user.profilePicture} alt="user" />
              <span>Md_taqui_imam_786</span>
            </div>
            {pic && pic.match(/\.(jpeg|jpg|png|gif)/g) != null ? (
              <img src={pic} alt="pst" id="createPost_final_image" />
            ) : (
              <video
                loop
                id="vedio_post"
                controls
                muted
                height="40%"
                src={pic}
                webkit-playsinline="true"
                playsinline="true"
              />
            )}
            
            <div className="createpost_caption">
              <input
                type="text"
                id="create_post_text"
                placeholder="Write Captions..."
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
              <button onClick={postImage}>UPLOAD</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreatePost;
